import styled from 'styled-components'

const LocationNavbarStyle = styled.div`
	--lnSlideMarginRight: var(--sp2-5x);
	--lnSlidePaddingV: var(--sp2-5x);
	--lnSlidePaddingH: var(--sp5x);
	--lnSelectPadding: var(--sp2-5x);
	--lnFilteredLocItemPadding: var(--sp2-5x);
	--lnFilteredLocItemMarginBottom: var(--sp4x);
	--lnFilteredLocItemImageMarginRight: var(--sp3x);
	--lnFilteredLocItemImageWidth: 34.97%;
	--lnFilteredLocItemTitleMarginBottom: var(--sp2x);

	--catTitleMarginTop: var(--sp4x);

	--subcategoriesMarginTopBottom: var(--sp8x) 0 var(--sp5x) 0;
	--resetAllMarginLeft: var(--sp3x);

	height: 100%;
	padding: 0 !important;
	padding-top: calc(var(--infoContPadding) * 2.5) !important;
	-ms-overflow-style: none;
	scrollbar-width: none;

	&::-webkit-scrollbar {
		display: none;
	}

	.title-reset-wrap {
		display: flex;
		align-items: center;
		margin: var(--subcategoriesMarginTopBottom);

		.reset-all {
			margin-left: var(--resetAllMarginLeft);
			cursor: pointer;
		}
	}

	.ln-info-container {
		display: flex;
		flex-direction: column;
		height: 100%;
		padding: var(--infoContPadding);
		padding-top: calc(0.5 * var(--infoContPadding));
		overflow-x: hidden;

		.ln-categories-slider-container,
		.ln-subcategories-slider-container {
			/* margin-bottom: var(--infoContPadding); */
			margin-right: calc(-1 * var(--infoContPadding));
			margin-left: calc(-1 * var(--infoContPadding));

			.ln-categories-slider,
			.ln-subcategories-slider {
				padding: 0 var(--infoContPadding);

				.ln-categories-slide,
				.ln-subcategories-slide {
					display: inline-block;
					width: auto;
					padding: 0 calc(var(--lnSlideMarginRight) / 2);
					cursor: pointer;

					&:last-child {
						padding-right: 0;
					}

					&:first-child {
						padding-left: 0;
					}

					.ln-cat {
						padding: var(--lnSlidePaddingV) var(--lnSlidePaddingH);
						border-radius: var(--sp2x);

						&.subcategory {
							border: 1px solid transparent;
						}

						@media (hover: hover) {
							&:hover {
								color: var(--primaryColor3);
							}
						}
					}
				}
			}

			.ln-categories-action-btn-right {
				right: var(--infoContPadding);
				z-index: 2;
			}

			.ln-categories-action-btn-left {
				left: var(--infoContPadding);
				z-index: 2;
			}
		}

		.ln-filtered-items-cont {
			/* flex: 1;
            overflow-y: scroll;
            -webkit-overflow-scrolling: touch; */
			/* -ms-overflow-style: none;
            scrollbar-width: none;
            
            &::-webkit-scrollbar {
                display: none;
            } */

			.ln-filtered-loc {
				padding: var(--lnFilteredLocItemPadding);
				margin-bottom: var(--lnFilteredLocItemMarginBottom);
				border-radius: var(--sp2x);
				cursor: pointer;

				.ln-image-cont {
					width: var(--lnFilteredLocItemImageWidth);
					margin-right: var(--lnFilteredLocItemImageMarginRight);

					.imageCont {
						--imagePaddingTop: 72.69%;

						border-radius: var(--sp2x);
						transform: translateZ(0);
						overflow: hidden;
					}
				}

				.ln-filtered-loc-inner {
					display: flex;

					.ln-loc-info {
						display: flex;
						flex-direction: column;
						justify-content: center;
						flex: 1;

						.ln-loc-title {
							margin-bottom: var(--lnFilteredLocItemTitleMarginBottom);
						}
					}
				}

				@media (hover: hover) {
					&:hover {
						.ln-loc-title {
							color: var(--primaryColor3);
						}

						.ln-loc-desc {
							color: var(--secondaryColor1);
						}
					}
				}
			}
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXLMin}) {
		--lnSlideMarginRight: var(--sp2x);
		--lnSlidePaddingV: var(--sp2x);
		--lnSlidePaddingH: var(--sp4x);
		--lnSelectPadding: var(--sp2x);
		--lnFilteredLocItemPadding: var(--sp2x);
		--lnFilteredLocItemMarginBottom: var(--sp3x);
		--lnFilteredLocItemImageMarginRight: var(--sp3x);
		--lnFilteredLocItemImageWidth: 34.97%;
		--lnFilteredLocItemTitleMarginBottom: var(--sp2x);

		--subcategoriesMarginTopBottom: var(--sp7x) 0 var(--sp3x) 0;
		--resetAllMarginLeft: var(--sp3x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeLMin}) {
		--lnSlideMarginRight: var(--sp1-5x);
		--lnSlidePaddingV: var(--sp1-5x);
		--lnSlidePaddingH: var(--sp3x);
		--lnSelectPadding: var(--sp1-5x);
		--lnFilteredLocItemPadding: var(--sp1-5x);
		--lnFilteredLocItemMarginBottom: var(--sp2x);
		--lnFilteredLocItemImageMarginRight: var(--sp3x);
		--lnFilteredLocItemImageWidth: 34.97%;
		--lnFilteredLocItemTitleMarginBottom: var(--sp2x);

		--subcategoriesMarginTopBottom: var(--sp7x) 0 var(--sp3x) 0;
		--resetAllMarginLeft: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeMMin}) {
		--lnSlideMarginRight: var(--sp1-5x);
		--lnSlidePaddingV: var(--sp1-5x);
		--lnSlidePaddingH: var(--sp3x);
		--lnSelectPadding: var(--sp1-5x);
		--lnFilteredLocItemPadding: var(--sp1-5x);
		--lnFilteredLocItemMarginBottom: var(--sp2x);
		--lnFilteredLocItemImageMarginRight: var(--sp3x);
		--lnFilteredLocItemImageWidth: 34.97%;
		--lnFilteredLocItemTitleMarginBottom: var(--sp2x);

		--subcategoriesMarginTopBottom: var(--sp7x) 0 var(--sp2-5x) 0;
		--resetAllMarginLeft: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeSMin}) {
		--lnSlideMarginRight: var(--sp1-5x);
		--lnSlidePaddingV: var(--sp1-5x);
		--lnSlidePaddingH: var(--sp3x);
		--lnSelectPadding: var(--sp1-5x);
		--lnFilteredLocItemPadding: var(--sp1-5x);
		--lnFilteredLocItemMarginBottom: var(--sp2x);
		--lnFilteredLocItemImageMarginRight: var(--sp3x);
		--lnFilteredLocItemImageWidth: 34.97%;
		--lnFilteredLocItemTitleMarginBottom: var(--sp2x);

		--subcategoriesMarginTopBottom: var(--sp7x) 0 var(--sp2-5x) 0;
		--resetAllMarginLeft: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXSMin}) {
		--lnSlideMarginRight: var(--sp1-5x);
		--lnSlidePaddingV: var(--sp1-5x);
		--lnSlidePaddingH: var(--sp3x);
		--lnSelectPadding: var(--sp1-5x);
		--lnFilteredLocItemPadding: var(--sp1-5x);
		--lnFilteredLocItemMarginBottom: var(--sp2x);
		--lnFilteredLocItemImageMarginRight: var(--sp3x);
		--lnFilteredLocItemImageWidth: 34.97%;
		--lnFilteredLocItemTitleMarginBottom: var(--sp1x);

		--subcategoriesMarginTopBottom: var(--sp7x) 0 var(--sp2-5x) 0;
		--resetAllMarginLeft: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.TabletSizeMin}) {
		--lnSlideMarginRight: var(--sp1-5x);
		--lnSlidePaddingV: var(--sp1-5x);
		--lnSlidePaddingH: var(--sp3x);
		--lnSelectPadding: var(--sp1-5x);
		--lnFilteredLocItemPadding: var(--sp1-5x);
		--lnFilteredLocItemMarginBottom: var(--sp2x);
		--lnFilteredLocItemImageMarginRight: var(--sp3x);
		--lnFilteredLocItemImageWidth: 34.97%;
		--lnFilteredLocItemTitleMarginBottom: var(--sp1x);

		--subcategoriesMarginTopBottom: var(--sp5x) 0 var(--sp2-5x) 0;
		--resetAllMarginLeft: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.MobileSize}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.TabletSizeSMin}) {
		--lnSlideMarginRight: var(--sp1-5x);
		--lnSlidePaddingV: var(--sp1-5x);
		--lnSlidePaddingH: var(--sp3x);
		--lnSelectPadding: var(--sp1-5x);
		--lnFilteredLocItemPadding: var(--sp1-5x);
		--lnFilteredLocItemMarginBottom: var(--sp2x);
		--lnFilteredLocItemImageMarginRight: var(--sp3x);
		--lnFilteredLocItemImageWidth: 34.97%;
		--lnFilteredLocItemTitleMarginBottom: var(--sp1x);

		--subcategoriesMarginTopBottom: var(--sp5x) 0 var(--sp2-5x) 0;
		--resetAllMarginLeft: var(--sp2x);
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.MobileSizeMin}) {
		--lnSlideMarginRight: var(--sp1-5x);
		--lnSlidePaddingV: var(--sp1-5x);
		--lnSlidePaddingH: var(--sp3x);
		--lnSelectPadding: var(--sp1-5x);
		--lnFilteredLocItemPadding: var(--sp1-5x);
		--lnFilteredLocItemMarginBottom: var(--sp2x);
		--lnFilteredLocItemImageMarginRight: var(--sp3x);
		--lnFilteredLocItemImageWidth: 34.97%;
		--lnFilteredLocItemTitleMarginBottom: var(--sp1x);

		--subcategoriesMarginTopBottom: var(--sp5x) 0 var(--sp2-5x) 0;
		--resetAllMarginLeft: var(--sp2x);
	}

	@media only screen and (max-height: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) and (orientation: landscape),
		(max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) and (hover: none) {
		.ln-info-container {
			.ln-filtered-items-cont {
				overflow-y: unset;
			}
		}
	}

	@media only screen and (hover: none) and (max-height: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) and (orientation: landscape),
		(max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) and (hover: none) {
		.ln-info-container {
			overflow-y: scroll;
			-ms-overflow-style: none;
			scrollbar-width: none;

			&::-webkit-scrollbar {
				display: none;
			}
		}
	}
`

export default LocationNavbarStyle
